'use strict';
window.WS = window.WS || {};

/* --------------------------------------------------------------------------
   Animations
   -------------------------------------------------------------------------- */
WS.initAnimations = function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.dataset.delay) el.style.transitionDelay = el.dataset.delay + 'ms';
      el.classList.add('in-view');
      obs.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });
  document.querySelectorAll('[data-animate]').forEach(function (el) { obs.observe(el); });
};

/* --------------------------------------------------------------------------
   Sticky header
   -------------------------------------------------------------------------- */
WS.initHeader = function () {
  var header = document.getElementById('ws-header');
  if (!header) return;
  function onScroll() { header.classList.toggle('ws-header--scrolled', window.scrollY > 10); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
};

/* --------------------------------------------------------------------------
   Mobile menu
   -------------------------------------------------------------------------- */
WS.initMobileMenu = function () {
  var openBtn  = document.getElementById('ws-menu-open');
  var closeBtn = document.getElementById('ws-menu-close');
  var drawer   = document.getElementById('ws-mobile-menu');
  var overlay  = document.getElementById('ws-menu-overlay');
  if (!openBtn || !drawer) return;
  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openBtn.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }
  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
  }
  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay)  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
};

/* --------------------------------------------------------------------------
   Footer accordion
   -------------------------------------------------------------------------- */
WS.initFooterAccordion = function () {
  document.querySelectorAll('.ws-footer-col-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth > 768) return;
      var col   = btn.closest('.ws-footer-col');
      var links = col && col.querySelector('.ws-footer-col-links');
      if (!col || !links) return;
      var opening = col.classList.toggle('is-open');
      links.style.maxHeight = opening ? links.scrollHeight + 'px' : '0';
    });
  });
};

/* --------------------------------------------------------------------------
   Wishlist
   Stores: [{ id: "12345", variantId: "67890", color: "Blue", size: "8" }, ...]
   -------------------------------------------------------------------------- */
WS.initWishlist = function () {
  var KEY = 'ws_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function getIds() {
    return getList().map(function (item) {
      return typeof item === 'object' ? String(item.id) : String(item);
    });
  }

  function syncBadge() {
    var badge = document.getElementById('ws-wishlist-badge');
    var count = getList().length;
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }

  function syncButtons() {
    var ids = getIds();
    document.querySelectorAll('.ws-wishlist-btn[data-product-id]').forEach(function (btn) {
      var active = ids.indexOf(String(btn.dataset.productId)) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
    syncBadge();
  }

  WS._wishlistGetList = getList;
  WS._wishlistSaveList = saveList;
  WS._wishlistGetIds = getIds;
  WS._wishlistSyncButtons = syncButtons;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ws-wishlist-btn[data-product-id]');
    if (!btn) return;
    var productId = String(btn.dataset.productId);
    var list      = getList();
    var ids       = list.map(function (i) { return typeof i === 'object' ? String(i.id) : String(i); });
    var idx       = ids.indexOf(productId);

    if (idx === -1) {
      /* Add — capture currently selected color and size from card */
      var card      = btn.closest('.ws-bs-card, .ws-pcard');
      var colorBtn  = card && card.querySelector('.ws-bs-swatch.is-active');
      var sizeBtn   = card && card.querySelector('.ws-bs-size.is-active');
      var atcBtn    = card && card.querySelector('.ws-bs-atc');
      var titleEl   = card && card.querySelector('.ws-bs-title, .ws-pcard-title');
      var prodName  = titleEl ? titleEl.textContent.trim() : 'Product';
      list.push({
        id:        productId,
        variantId: atcBtn ? String(atcBtn.dataset.variantId || '') : '',
        color:     colorBtn ? (colorBtn.dataset.optionValue || '') : '',
        size:      sizeBtn  ? (sizeBtn.dataset.optionValue  || '') : ''
      });
      if (WS.toast) WS.toast('♥ ' + prodName + ' added to wishlist', 'success');
    } else {
      var cardR    = btn.closest('.ws-bs-card, .ws-pcard');
      var titleElR = cardR && cardR.querySelector('.ws-bs-title, .ws-pcard-title');
      var prodNameR= titleElR ? titleElR.textContent.trim() : 'Product';
      list.splice(idx, 1);
      if (WS.toast) WS.toast(prodNameR + ' removed from wishlist', 'info');
    }

    saveList(list);
    syncButtons();

    /* Re-render wishlist drawer if open */
    var drawer = document.getElementById('ws-wishlist-drawer');
    if (drawer && drawer.classList.contains('is-open') && WS.renderWishlist) {
      WS.renderWishlist(true); /* force refresh — item added/removed */
    }
  });

  syncButtons();
};

/* --------------------------------------------------------------------------
   Toast notifications
   -------------------------------------------------------------------------- */
WS.toast = function (message, type) {
  /* type: 'success' | 'error' | 'info' */
  type = type || 'success';

  var container = document.getElementById('ws-toast-container');
  if (!container) return;

  var toast = document.createElement('div');
  toast.className = 'ws-toast ws-toast--' + type;

  var icons = {
    success: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>',
    error:   '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
    info:    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
  };

  toast.innerHTML = (icons[type] || icons.info) + '<span>' + message + '</span>';
  container.appendChild(toast);

  /* Animate in */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
  });

  /* Auto dismiss after 2s */
  var timer = setTimeout(function () { WS.dismissToast(toast); }, 2000);

  /* Dismiss on click */
  toast.addEventListener('click', function () {
    clearTimeout(timer);
    WS.dismissToast(toast);
  });
};

WS.dismissToast = function (toast) {
  toast.classList.remove('is-visible');
  setTimeout(function () {
    if (toast.parentNode) toast.parentNode.removeChild(toast);
  }, 300);
};

/* --------------------------------------------------------------------------
   Cart utilities
   -------------------------------------------------------------------------- */
WS.fmtMoney = function (cents) {
  return '\u20B9' + Math.round(cents / 100).toLocaleString('en-IN');
};

WS.updateCartBadge = function (count) {
  /* Try by ID first, then by class */
  var badge = document.getElementById('ws-cart-badge') || document.querySelector('.ws-cart-badge');
  var countLbl = document.getElementById('ws-cart-count-label');
  if (badge) {
    badge.textContent = String(count);
    badge.style.cssText = count > 0
      ? 'display:flex!important;visibility:visible!important;'
      : 'display:none!important;';
  }
  if (countLbl) countLbl.textContent = count;
};

WS.refreshCart = function (cart) {
  WS.updateCartBadge(cart.item_count);

  /* Shipping bar */
  var bar  = document.getElementById('ws-cart-ship-bar');
  var fill = document.getElementById('ws-cart-ship-fill');
  var text = document.getElementById('ws-cart-ship-text');
  if (bar && fill && text) {
    var threshold = parseInt(bar.dataset.threshold || '0', 10);
    if (threshold > 0) {
      bar.style.display = cart.item_count > 0 ? '' : 'none';
      var cartSubtotal = cart.items_subtotal_price || cart.total_price;
      var pct = Math.min(100, Math.round(cartSubtotal * 100 / threshold));
      fill.style.width = pct + '%';
      if (pct >= 100) {
        fill.classList.add('is-free');
        text.classList.add('is-free');
        text.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg> You\'ve unlocked free shipping!';
      } else {
        fill.classList.remove('is-free');
        text.classList.remove('is-free');
        var away = threshold - cartSubtotal;
        text.innerHTML = '<svg viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Add ' + WS.fmtMoney(away) + ' more for free shipping';
      }
    }
  }

  var body     = document.getElementById('ws-cart-body');
  var footer   = document.getElementById('ws-cart-footer');
  var subtotal = document.getElementById('ws-cart-subtotal');

  if (!body) return;
  body.innerHTML = '';

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="ws-cart-empty">'
      + '<svg class="ws-cart-empty-icon" viewBox="0 0 24 24">'
      + '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>'
      + '<line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>'
      + '</svg><p>Your cart is empty</p>'
      + '<a href="/collections/all" class="ws-cart-checkout-btn" style="padding:10px 20px;width:auto;">Start Shopping</a>'
      + '</div>';
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = '';

  cart.items.forEach(function (item) {
    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="ws-cart-item-variant">' + item.variant_title + '</span>' : '';
    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' : '';
    var el = document.createElement('div');
    el.className = 'ws-cart-item';
    el.dataset.key = item.key;
    el.dataset.variantId = String(item.variant_id || '');

    el.innerHTML = '<a href="' + item.url + '" class="ws-cart-item-img">' + imgHtml + '</a>'
      + '<div class="ws-cart-item-info">'
        + '<div class="ws-cart-item-top">'
          + '<a href="' + item.url + '" class="ws-cart-item-title">' + item.product_title + '</a>'
          + '<button class="ws-cart-item-delete" data-key="' + item.key + '" type="button" aria-label="Remove">'
            + '<svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/>'
            + '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>'
            + '<path d="M10 11v6M14 11v6M9 6V4h6v2"/></svg>'
          + '</button>'
        + '</div>'
        + variantHtml
        + '<div class="ws-cart-item-row">'
          + '<div class="ws-qty">'
            + '<button class="ws-qty-btn" data-key="' + item.key + '" data-action="decrease" type="button" aria-label="Decrease">&#8722;</button>'
            + '<span class="ws-qty-val">' + item.quantity + '</span>'
            + '<button class="ws-qty-btn" data-key="' + item.key + '" data-action="increase" type="button" aria-label="Increase">+</button>'
          + '</div>'
          + '<span class="ws-cart-item-price">' + WS.fmtMoney(item.final_line_price) + '</span>'
        + '</div>'
      + '</div>';
    body.appendChild(el);
  });

  if (subtotal) subtotal.textContent = WS.fmtMoney(cart.items_subtotal_price || cart.total_price);


};

WS.addToCart = function (variantId, quantity, onSuccess, onError) {
  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
  })
  .then(function (r) { return r.json(); })
  .then(function () { return fetch('/cart.js?_=' + Date.now()).then(function (r) { return r.json(); }); })
  .then(function (cart) {
    WS.refreshCart(cart);
    if (onSuccess) onSuccess(cart);
    var cartDrawer = document.getElementById('ws-cart-drawer');
    if (cartDrawer && WS.openDrawer) WS.openDrawer(cartDrawer);
  })
  .catch(function (err) {
    if (WS.toast) WS.toast('Could not add to cart. Please try again.', 'error');
    if (onError) onError(err);
  });
};

/* --------------------------------------------------------------------------
   Lazy images
   -------------------------------------------------------------------------- */
WS.initLazyImages = function () {
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    img.style.transition = 'opacity 0.3s ease';
    if (img.complete) { img.style.opacity = '1'; return; }
    img.style.opacity = '0';
    img.addEventListener('load',  function () { img.style.opacity = '1'; }, { once: true });
    img.addEventListener('error', function () { img.style.opacity = '1'; }, { once: true });
  });
};

/* --------------------------------------------------------------------------
   Init
   -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  WS.initAnimations();
  WS.initHeader();
  WS.initMobileMenu();
  WS.initFooterAccordion();
  WS.initWishlist();
  WS.initLazyImages();
});